<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h4 v-if="user">
          Welcome, &nbsp; {{ user.email }}
        </h4>
        <p>
          Membership Type:
          <b>{{ user && user.premium ? "Premium" : "Free" }}</b>
        </p>
        <div v-if="user && user.premium">
          <p>
            Email: <input v-model="user.email" type="text" maxlength="100" />
          </p>
          <p style="display: inline;">
            Pick Notifications:
          </p>

          <div style="margin: 8px 0;">
            <label>
              <input
                v-model="notifyEmail"
                type="checkbox"
              />
              Email
            </label>
            <input
              v-if="notifyEmail"
              v-model="contactEmail"
              type="text"
              placeholder="Enter Contact Email"
              style="margin-left: 8px;"
            />
          </div>

          <div style="margin: 8px 0;">
            <label>
              <input
                v-model="notifyPush"
                type="checkbox"
              />
              Push Notification
            </label>
            <p v-if="notifyPush" style="font-size: 13px; color: #666; margin: 4px 0 0 24px;">
              Visit <a href="https://m.stumpthespread.com/myaccount" target="_blank" style="color: #e94560;">StumptheSpread.com/myaccount</a> on your phone to set up push notifications.
            </p>
          </div>

          <div v-if="user.notify_sms || user.contact_method === 2" style="margin: 8px 0;">
            <label>
              <input
                v-model="notifySms"
                type="checkbox"
              />
              Text Message
            </label>
            <span style="font-size: 11px; color: #999; margin-left: 4px;">(no longer available for new sign-ups — please use Push Notifications instead)</span>
            <div v-if="notifySms" style="margin-top: 4px;">
              <select
                id="phoneList"
                v-model="phone"
                name="phones"
              >
                <option v-for="p in phoneOpts" :key="p.value" :value="p">
                  {{ p.key }}
                </option>
              </select>
              <input
                v-model="contactPhone"
                type="text"
                placeholder="Enter Contact Phone"
                style="margin-left: 8px;"
              />
            </div>
          </div>
        </div>
        <router-link
          v-if="user && !user.premium"
          :to="{ path: '/packages/all' }"
          class="big-btn red"
        >
          Upgrade
        </router-link>
        <button
          v-if="user && user.premium"
          class="big-btn orange"
          @click.prevent="save()"
        >
          Update
        </button>
        <router-link :to="{ path: '/changepassword' }" class="big-btn blue">
          Change Password
        </router-link>
        <!-- post END here -->
      </div>
      <!-- main-colum END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import AuthRepository from "../data/auth.repository";
import _ from "lodash";
import { store } from "../store/store";
export default {
  data() {
    return {
      notifyEmail: false,
      notifyPush: false,
      notifySms: false,
      contactEmail: "",
      contactPhone: "",
      phone: {},
      phoneOpts: [
        { key: "Select Carrier", value: 0 },
        { key: "Verizon", value: 2 },
        { key: "T-Mobile", value: 3 },
        { key: "Sprint", value: 4 },
        { key: "U.S. Cellular", value: 5 },
        { key: "Virgin Mobile", value: 6 },
        { key: "Tracfone", value: 7 },
        { key: "Metro PCS", value: 8 },
        { key: "Boost Mobile", value: 9 },
        { key: "Cricket", value: 10 },
        { key: "Nextel", value: 11 },
        { key: "Alltel", value: 12 },
        { key: "Ptel", value: 13 },
        { key: "Suncom", value: 14 },
        { key: "Qwest", value: 15 },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
  },
  mounted() {
    var u = this.$store.state.currentUser;
    // Initialize from new boolean flags (with fallback to legacy contact_method)
    if (u.notify_email !== undefined) {
      this.notifyEmail = !!u.notify_email;
    } else {
      this.notifyEmail = u.contact_method === 1;
    }
    if (u.notify_push !== undefined) {
      this.notifyPush = !!u.notify_push;
    }
    if (u.notify_sms !== undefined) {
      this.notifySms = !!u.notify_sms;
    } else {
      this.notifySms = u.contact_method === 2;
    }

    // Initialize contact fields
    if (u.contact_method === 1 && u.contact_email) {
      this.contactEmail = u.contact_email;
    } else if (u.email) {
      this.contactEmail = u.email;
    }
    if (u.contact_method === 2 && u.contact_email) {
      this.contactPhone = u.contact_email;
    }

    if (!u.contact_phone || u.contact_phone === 0) {
      this.phone = this.phoneOpts[0];
    } else if (u.contact_phone) {
      this.phone =
        _.find(this.phoneOpts, ["value", u.contact_phone]) ||
        this.phoneOpts[0];
    }
  },
  methods: {
    save() {
      var payload = {
        id: this.user.id,
        email: this.user.email,
        notify_email: this.notifyEmail ? 1 : 0,
        notify_push: this.notifyPush ? 1 : 0,
        notify_sms: this.notifySms ? 1 : 0,
        contact_method: this.notifySms ? 2 : this.notifyEmail ? 1 : 0,
        contact_email: this.notifyEmail
          ? this.contactEmail
          : this.notifySms
            ? this.contactPhone
            : "",
        contact_phone: this.notifySms ? this.phone.value || 0 : 0,
      };
      AuthRepository.save(payload)
        .then((result) => {
          this.$store.dispatch("getStoredUser");
          this.$root.$refs.toastr.s("User saved");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("getStoredUser").then(() => {
      const u = store.state.currentUser;
      if (!u || !u.id) return next("/");
      next();
    });
  },
  metaInfo: {
    title: "My Account",
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// MyAccount.vue?8e00e10a